module.exports = __webpack_public_path__ + "components/flag/static/square/lc-7118ca0d6e3ec35548054daa2501382c.svg";